<template>
   <div class="brands-wrapper">
      <!-- Swiper Slides -->
      <swiper :slides-per-view="slidesPerView" :observer="true" :centeredSlides="centeredSlides" :space-between="spaceBetweenSlides" @slideChange="onSlideChange" ref="brands">
         <swiper-slide v-for="(brand, key, brandIndex) in brands" :key="brandIndex" :class="{ 'has-mix-brand': isMixBrand(brand) }">
            <BrandItem
               :brand="brand"
               :is-active="activeSlide == brandIndex"
               :flight-identifier="flightIdentifier"
               :price-per-leg="pricePerLeg"
               :data="data"
               :width="brandItemWidth"
               :show-features="showBrandFeatures"
               :features-scroll-top="featuresScrollTop"
               @brand-selected="handleBrandSelected"
               @toggle-features="showBrandFeatures = !showBrandFeatures"
               @features-scroll="featuresScrollTop = $event" />
         </swiper-slide>
      </swiper>

      <!-- Bullets -->
      <div class="slider-navigation" v-if="Object.keys(brands).length > 1">
         <div class="bullets-container">
            <div class="viewport-highlighter" :style="highlighterStyle"></div>
            <ul>
               <li v-for="(brand, key, bulletIndex) in brands" :key="bulletIndex" :class="{ active: brand.selected }" @click="handleBullet(bulletIndex)" class="masked-background-dark"></li>
            </ul>
         </div>
      </div>

      <!-- Navigation -->
      <div class="navigation-buttons-container masked-hidden">
         <button class="slider-prev" @click="handlerPrevSlide" v-if="showArrows.prev">
            <i class="gts-icon icon-arrow-left"></i>
         </button>
         <button class="slider-next" @click="handlerNextSlide" v-if="showArrows.next">
            <i class="gts-icon icon-arrow-right"></i>
         </button>
      </div>

      <SsrSelection :ssrs="ssrs" :flight-identifer="flightIdentifier" :selected-brand="SelectedBrandIs" v-if="ShowSsr" />
   </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination]);
import BrandItem from "@/components/structural/flight/checkout/brands/BrandItem.vue";
import SsrSelection from "@/components/structural/flight/checkout/brands/SsrSelection.vue";

export default {
   name: "FlightBrands",
   props: {
      brands: Object,
      legIndex: String,
      flightIdentifier: String,
      pricePerLeg: Boolean,
      identifierList: Array,
      data: Object,
      ssrs: Object,
   },
   components: {
      Swiper,
      SwiperSlide,
      BrandItem,
      SsrSelection,
   },
   data() {
      return {
         showSsr: true,
         slider: null,
         activeSlide: null,
         activeBullet: null,
         showArrows: {
            prev: null,
            next: null,
         },
         centeredSlides: false,
         showBrandFeatures: true,
         featuresScrollTop: 0,
      };
   },

   created() {
      console.log(this.$store.state.flight);
   },
   computed: {
      ShowSsr() {
         return typeof this.ssrs === "object" && this.ssrs !== null && Object.keys(this.ssrs).length > 0 && this.showSsr;
      },
      slidesPerView() {
         return "auto";
      },
      effectiveSlidesPerView() {
         // Calculate effective slides per view for bullet calculations
         const storeInnerWidth = this.$store.state.app.clientInformations.innerWidth;

         if (storeInnerWidth <= 550) {
            return 1;
         } else if (storeInnerWidth <= 992) {
            return 2;
         } else {
            return 3;
         }
      },
      spaceBetweenSlides() {
         const storeInnerWidth = this.$store.state.app.clientInformations.innerWidth;
         if (storeInnerWidth <= 550) {
            return 10;
         } else if (storeInnerWidth <= 992) {
            return 15;
         } else {
            return 32;
         }
      },
      SelectedBrandIs() {
         const brandItems = this.brands;

         for (const item in brandItems) {
            if (brandItems[item].selected) {
               return brandItems[item].brandName;
            }
         }
         return null;
      },
      brandItemWidth() {
         // Let swiper handle width based on slidesPerView
         return "100%";
      },
      hasMixBrand() {
         const hasCrossBrand = this.$store.state.flight.checkout.response.hasCrossBrand;

         if (!hasCrossBrand) {
            return false;
         }

         return Object.values(this.brands).some((brand) => brand.brandTitle && brand.brandTitle.includes("&"));
      },
      highlighterStyle() {
         const bulletWidth = 20; // bullet width in px
         const bulletMarginEach = 6; // 0.375rem = 6px per side
         const bulletTotalWidth = bulletWidth + bulletMarginEach * 2; // width + left margin + right margin
         const padding = 12; // container padding 0.75rem = 12px

         const totalSlides = Object.keys(this.brands).length;
         const currentIndex = this.activeBullet || 0;

         // Calculate the start index for the viewport
         // If we're near the end, show the last N items
         let startIndex = currentIndex;
         if (currentIndex + this.effectiveSlidesPerView > totalSlides) {
            startIndex = totalSlides - this.effectiveSlidesPerView;
         }
         // Ensure we don't go below 0
         startIndex = Math.max(0, startIndex);

         const left = padding + startIndex * bulletTotalWidth;

         // Width covers effectiveSlidesPerView bullets
         const width = this.effectiveSlidesPerView * bulletTotalWidth;

         return {
            left: `${left}px`,
            width: `${width}px`,
         };
      },
   },

   methods: {
      isMixBrand(brand) {
         const hasCrossBrand = this.$store.state.flight.checkout.response.hasCrossBrand;

         // hasCrossBrand false ise class ekleme
         if (!hasCrossBrand) {
            return false;
         }

         // hasCrossBrand true ise normal logic
         if (!brand.brandTitle || !brand.brandTitle.includes("&")) {
            return false;
         }

         const parts = brand.brandTitle.split("&").map((part) => part.trim());
         // Mix brand only if parts are different
         return parts[0] !== parts[1];
      },
      onSlideChange(swiper) {
         const self = this;
         const totalSlides = Object.keys(self.brands).length;

         // If all slides fit in view (centeredSlides mode), use real active index
         if (totalSlides <= self.effectiveSlidesPerView && swiper.realIndex !== undefined) {
            self.activeBullet = swiper.realIndex;
            self.activeSlide = swiper.realIndex;
         } else {
            self.activeBullet = swiper.activeIndex;
            self.activeSlide = swiper.activeIndex;
         }
         self.updateArrowsVisibility(swiper);
      },
      updateArrowsVisibility(swiper) {
         const self = this;
         const totalSlides = Object.keys(self.brands).length;

         // Check if we need arrows at all
         if (totalSlides <= self.effectiveSlidesPerView) {
            self.showArrows = {
               prev: false,
               next: false,
            };
            return;
         }

         // Update arrows based on current position
         self.showArrows = {
            prev: swiper.activeIndex > 0,
            next: swiper.activeIndex < totalSlides - self.effectiveSlidesPerView,
         };
      },
      handleBullet(index) {
         const self = this;
         self.slider.slideTo(index);
         self.activeBullet = index;
         self.updateArrowsVisibility(self.slider);
      },
      handlerNextSlide() {
         const self = this;
         self.slider.slideNext();
         self.updateArrowsVisibility(self.slider);
      },
      handlerPrevSlide() {
         const self = this;
         self.slider.slidePrev();
         self.updateArrowsVisibility(self.slider);
      },
      handleBrandSelected() {
         this.showSsr = true;
      },
   },
   watch: {
      brands: {
         handler: function (brands) {
            brands;

            this.slider = this.$refs.brands.$el.swiper;

            var selectedBrandIndex;

            Object.keys(this.brands).forEach((brand, index) => {
               if (this.brands[brand].selected) {
                  selectedBrandIndex = index;
               }
            });

            const totalSlides = Object.keys(this.brands).length;

            // Center slides if there are fewer slides than the effective view
            if (totalSlides <= this.effectiveSlidesPerView) {
               this.centeredSlides = true;
            } else {
               this.centeredSlides = false;
            }

            // Simulate bullet click for selected brand
            if (selectedBrandIndex !== undefined && this.slider) {
               setTimeout(() => {
                  this.handleBullet(selectedBrandIndex);
               }, 150);
            }

            // Initial arrow visibility
            this.updateArrowsVisibility(this.slider);
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.swiper-wrapper {
   justify-content: center;
}
.brands-wrapper {
   padding: 1.5rem 2.5rem;
   position: relative;
   overflow: hidden;
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;

   .swiper-container {
      overflow: hidden;
      padding: 2rem 1rem;
      width: 100%;
      max-width: 100%;

      .swiper-wrapper {
         align-items: center;
         justify-content: center;
      }
   }
   .swiper-slide {
      width: 280px;
      height: auto;
      display: flex;
      justify-content: center;

      @media (max-width: 992px) {
         width: 260px;
      }

      @media (max-width: 550px) {
         width: 100%;
      }
   }

   .swiper-slide.has-mix-brand {
      width: 420px;

      @media (max-width: 992px) {
         width: 360px;
      }

      @media (max-width: 550px) {
         width: 100%;
      }
   }
   .slider-navigation {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      .bullets-container {
         position: relative;
         padding: 0.75rem;
         background-color: var(--blue-400-lighter);
         border-radius: 12rem;

         .viewport-highlighter {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            height: calc(100% - 12px);
            // border: 1px solid var(--gray-300);
            border-radius: 12rem;
            // background-color: rgba(var(--accent-primary-rgb), 0.1);
            background-color: var(--gray-0);
            transition: all 0.3s ease;
            pointer-events: none;
            z-index: 1;
         }

         ul {
            display: flex;
            position: relative;
            z-index: 2;

            li {
               width: 20px;
               height: 20px;
               display: inline-block;
               border-radius: 50%;
               background-color: var(--gray-300);
               margin: 0 0.375rem;
               cursor: pointer;
               transition: all 0.3s ease;

               &:hover {
                  background-color: var(--gray-400);
               }

               &.active {
                  background-color: var(--accent-primary);
               }
            }
         }
      }
   }
   .slider-prev,
   .slider-next {
      background: none !important;
      position: absolute;
      top: 190px;
      transform: translateY(-50%);
      margin: auto;
      z-index: 99;
   }

   .slider-prev {
      left: 0;
   }
   .slider-next {
      right: 0;
   }
}
</style>
